import { combineReducers } from 'redux';
import { toasts } from './reducers/toast';
import { fullloader } from './reducers/loaders';
import {loggeduserDetails} from './reducers/userDetails';
import {groupDetail} from './reducers/groupdetail';
import {groupList} from './reducers/grouplist';

import {eventList} from './reducers/eventlist';
import {libraryList} from './reducers/librarylist';
import {mytapList} from './reducers/mytaps';
import {calendarList} from './reducers/calendarlist';
import {eventSubscription} from './reducers/subscribe';
import {imageDetails} from './reducers/image';
import {apikeyList} from './reducers/appkeyList';

const rootReducer = combineReducers({
    toasts,
    fullloader,
    loggeduserDetails,
    eventList,
    calendarList,
    imageDetails,
    libraryList,
    eventSubscription,
    groupDetail,
    mytapList,
    groupList,
    apikeyList
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/redux/rootReducer.js